import BInputNumber from './BInputNumber';
export default BInputNumber;
